<template>
	<!-- banner -->
	<section v-if="topoProdutos != ''" class="home-section hero"
		:style="{ backgroundImage: 'url(' + $imgURL + topoProdutos[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
		<div class="row d-flex texto-banner-internas">
			<div class="container">
				<p class="titulo-cel">{{ topoProdutos[0].itiNome }}</p>
			</div>
		</div>
	</section>
	<!-- END banner -->

	<!-- produtos -->
	<section>
		<div class="produtos">
			<div class="container">
				<div class="row">

					<div class="col-lg-3 col-md-6 col-sm-8 order-1 ">
						<div class="heading-section">
							<span class="subheading nl-10">Nossas Linhas</span>
							<ul class="filter-catagories mn-produto">
								<li v-for="menu in segmentospais" :key="menu.sgiId">
									<a @click.prevent="filtraProdutos(menu.sgiId)" href="#"><span
											class="fa fa-chevron-right mr-2"></span>{{ menu.sgiNomeSegmento }}</a>
								</li>

							</ul>
						</div>
					</div>

					<div v-if="ListaProdutosSegmento != ''" class="col-lg-9 order-2">
						<h2>{{ ListaProdutosSegmento[0].insInstitucionalSegmentos[0].sgiNomeSegmento }}</h2>

						<div class="row" style="margin-top: 30px;">
							<div v-for="produto in ListaProdutosSegmento" :key="produto.itiId" class="col-md-4">
								<div class="project img shadow  d-flex justify-content-center align-items-center"
									:style="{ backgroundImage: 'url(' + $imgURL + produto.insInstitucionalImagens[0].itgUrlImagem + ')' }">
									<div class="overlay"></div>
									<div class="text text-center p-4">
										<h3><router-link
												:to="'/produtosdetalhe/' + produto.itiId + '/' + formataLink(produto.itiNome)">
												{{ produto.itiNome }}
											</router-link>
										</h3>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- END produtos -->


</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios'
import { useRoute } from 'vue-router';


export default {
	name: 'ProdutosView',
	components: {

	},
	setup() {
		const route = useRoute();
		const id = route.params.id;
		const nome = route.params.nome;
		return {
			id,
			nome
		};
	},

	data: () => ({
		topoProdutos: [],
		ListaProdutosTodos: [],
		ListaProdutosSegmento: [],
		segmentospais: [],
		NomeCategoria: "",
	}),

	methods: {

		filtraProdutos(value) {
			const segId = Number(value); // garanta que seja número, se vier string

			this.ListaProdutosSegmento = this.ListaProdutosTodos.filter(prod =>
				prod.insInstitucionalSegmentos.some(
					w => w.insSegmentos.sgiId === segId
				)
			);
		},

		formataLink(value) {
			return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
		},

		carregaMetas(texto) {
			useHead({
				title: 'Produtos - Induscapas',
				meta: [
					{ name: "description", content: texto },
					{ name: "author", content: "Induscapas" },
					{ httpEquiv: "Content-Language", content: "pt-BR" },
					{ charset: "UTF-8" },
					{ name: "robots", content: "index, follow" },
				],
			})
		},

		toggleAccordion(index) {
			this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
		},
	},

	async created() {
		this.carregaMetas("---");

		//aqui busca o banner
		await axios.get('/Process/InsInstitucional/institucional/38/topoprodutos/0/x')
			.then(response => {
				this.topoProdutos = response.data;
				//console.log('topo produtos')
				//console.log(this.topoProdutos)
			})
			.catch(error => {
				console.error(error);
			});

		await axios.get('/Process/InsSegmentos/GetAll') // padrão para fazer o menu txt lateral produtos //
			.then(response => {
				this.segmentospais = response.data.filter(x => x.sgiIdPai == 0 && x.sgiVisivel).sort((a, b) => {
					const nomeA = a.sgiNomeSegmento || "";
					const nomeB = b.sgiNomeSegmento || "";
					return nomeA.localeCompare(nomeB);
				});
				//console.log('segmento pai')
				//console.log(this.segmentospais)
				this.NomeCategoria = this.segmentospais[0].sgiNomeSegmento;
			})
			.catch(error => {
				console.error(error);
			});

		//lista de todos os produtos
		await axios.get('/Process/InsInstitucional/institucional/39/listaprodutos/0/x')
			.then(response => {
				this.ListaProdutosTodos = response.data;
				this.ListaProdutosSegmento = this.ListaProdutosTodos.filter(x => x.insInstitucionalSegmentos.some(w => w.insSegmentos.sgiId == this.segmentospais[0].sgiId))
				//console.log('ListaProdutosTodos')
				//console.log(this.ListaProdutosTodos)
				//console.log('ListaProdutosSegmento')
				//console.log(this.ListaProdutosSegmento)
			})
			.catch(error => {
				console.error(error);
			});

		if (this.id != '') {
			this.filtraProdutos(this.id);
		}


	},
}

</script>

<style scoped></style>
